import React, { useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import "./../assets/css/sidebar.css";
import logovefase from "./../assets/katanalogo.png";
import Accordion from "react-bootstrap/Accordion";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import axios from 'axios';
import AIChat from './AIChat';

const urlws = "https://api.mrcirp.com/public/whatsapp";

const Sidebar = ({ children }) => {
  let navigate = useNavigate();
    const [dataws, setDataws] = useState([]);

  //////////////Datos de Usuario Logueado/////////////////////////
  const [users, setUsers] = useState([]);
  
  //////////////Estados para Notificaciones/////////////////////////
  const [notificaciones, setNotificaciones] = useState([]);
  const [showNotificaciones, setShowNotificaciones] = useState(false);
  const [nuevaNotificacion, setNuevaNotificacion] = useState({
    titulo: '',
    mensaje: '',
    tipo: 'info'
  });

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      try {
        const user = JSON.parse(loginUserJSON);
        setUsers(user);
        
        // Cargar datos completos del usuario desde el endpoint
        if (user.id) {
          axios.get(`https://api.mrcirp.com/public/userpanel/${user.id}`)
            .then((response) => {
              if (response.data && response.data[0]) {
                const userData = response.data[0];
                // Actualizar el estado con los datos completos incluyendo membresía
                setUsers(prevUser => ({
                  ...prevUser,
                  ...userData
                }));
                // Actualizar también localStorage con los datos completos
                window.localStorage.setItem("loginUser", JSON.stringify({
                  ...user,
                  ...userData
                }));
                // Debug: verificar campos de membresía
                if (userData.membresia) {
                  console.log('Membresía del usuario:', userData.membresia);
                  console.log('Fecha de creación:', userData.fecha_creacion);
                }
              }
            })
            .catch((error) => {
              console.error('Error cargando datos del usuario:', error);
            });
        }
      } catch (error) {
        console.error('Error parsing loginUser:', error);
      }
    }
  }, []);

  const [isOpen, setIsOpen] = useState(true);
  const toggle = () => setIsOpen(!isOpen);

  const handlelogout = () => {
    window.localStorage.removeItem("loginUser");
    navigate("/");
  };

  const peticionGetws = async () => {
    await axios.get(urlws).then((response) => {
      setDataws(response.data[0]);
    });
  };

  useEffect(() => {
    peticionGetws();
  }, []);

  //////////////Funciones para Notificaciones/////////////////////////
  const cargarNotificaciones = async () => {
    try {
      const response = await axios.get('https://api.mrcirp.com/public/notificaciones');
      setNotificaciones(response.data);
    } catch (error) {
      console.error('Error al cargar notificaciones:', error);
      // En caso de error, usar notificaciones simuladas como fallback
      const notificacionesSimuladas = [
        {
          id: 1,
          titulo: 'Nuevo curso disponible',
          mensaje: 'Se ha añadido un nuevo curso a la academia. ¡Échale un vistazo!',
          tipo: 'info',
          fecha_creacion: '2024-01-15',
          leida: false
        },
        {
          id: 2,
          titulo: 'Mantenimiento programado',
          mensaje: 'El sistema estará en mantenimiento el domingo de 2:00 AM a 4:00 AM.',
          tipo: 'warning',
          fecha_creacion: '2024-01-14',
          leida: true
        },
        {
          id: 3,
          titulo: '¡Bienvenido!',
          mensaje: 'Gracias por unirte a KATANA Academy. ¡Comienza tu aprendizaje hoy!',
          tipo: 'success',
          fecha_creacion: '2024-01-13',
          leida: true
        }
      ];
      setNotificaciones(notificacionesSimuladas);
    }
  };

  const toggleNotificaciones = () => {
    setShowNotificaciones(!showNotificaciones);
    if (!showNotificaciones) {
      cargarNotificaciones();
    }
  };

  const marcarComoLeida = async (id) => {
    try {
      await axios.put(`https://api.mrcirp.com/public/notificaciones/${id}/leer`);
      setNotificaciones(prev => 
        prev.map(notif => 
          notif.id === id ? { ...notif, leida: true } : notif
        )
      );
    } catch (error) {
      console.error('Error al marcar como leída:', error);
      // Actualizar localmente aunque falle la API
      setNotificaciones(prev => 
        prev.map(notif => 
          notif.id === id ? { ...notif, leida: true } : notif
        )
      );
    }
  };

  const enviarNotificacion = async () => {
    if (!nuevaNotificacion.titulo || !nuevaNotificacion.mensaje) {
      alert('Por favor completa todos los campos');
      return;
    }

    try {
      const notificacionData = {
        titulo: nuevaNotificacion.titulo,
        mensaje: nuevaNotificacion.mensaje,
        tipo: nuevaNotificacion.tipo,
        admin_id: users.id || 1,
        admin_nombre: users.nombre || 'Administrador',
        prioridad: 'media',
        mostrar_en_landing: 1
      };

      await axios.post('https://api.mrcirp.com/public/notificaciones', notificacionData);
      
      // Recargar notificaciones después de crear una nueva
      await cargarNotificaciones();
      
      setNuevaNotificacion({ titulo: '', mensaje: '', tipo: 'info' });
      alert('Notificación enviada exitosamente');
    } catch (error) {
      console.error('Error al enviar notificación:', error);
      alert('Error al enviar la notificación');
    }
  };

  const getTipoColor = (tipo) => {
    switch (tipo) {
      case 'success': return 'success';
      case 'warning': return 'warning';
      case 'error': return 'danger';
      default: return 'info';
    }
  };

  const getTipoIcono = (tipo) => {
    switch (tipo) {
      case 'success': return <FaIcons.FaCheckCircle />;
      case 'warning': return <FaIcons.FaExclamationTriangle />;
      case 'error': return <FaIcons.FaTimesCircle />;
      default: return <FaIcons.FaInfoCircle />;
    }
  };

  const notificacionesNoLeidas = notificaciones.filter(n => !n.leida).length;

  // Calcular días restantes de prueba para Katana Demo
  const calcularDiasRestantes = () => {
    // Verificar que el usuario tenga membresía Demo
    if (!users || !users.membresia) {
      return null;
    }
    
    // Verificar que sea Katana Demo (case insensitive)
    const membresia = String(users.membresia).trim();
    if (membresia.toLowerCase() !== 'katana demo') {
      return null;
    }
    
    // Verificar que tenga fecha de creación
    if (!users.fecha_creacion) {
      return null;
    }
    
    try {
      const fechaCreacion = new Date(users.fecha_creacion);
      const fechaActual = new Date();
      
      // Validar que la fecha sea válida
      if (isNaN(fechaCreacion.getTime())) {
        return null;
      }
      
      // Calcular diferencia en días
      const diferenciaMs = fechaActual - fechaCreacion;
      const diasTranscurridos = Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));
      const diasRestantes = 15 - diasTranscurridos;
      
      // Retornar días restantes (mínimo 0)
      return diasRestantes > 0 ? diasRestantes : 0;
    } catch (error) {
      console.error('Error calculando días restantes:', error);
      return null;
    }
  };

  const diasRestantes = calcularDiasRestantes();

  return (
    <div>
      {/* ---------------------------------------Navbar------------------------------------------------ */}
      <Nav className="justify-content-end Nav1" activeKey="/home">
        <Nav.Item>
          <Nav.Link eventKey="link-1" className="nav-text-white">
            <FaIcons.FaUserCircle  /> 
            {users.codigo_membresia && (
              <span className="me-2 badge bg-info text-dark" title="Código de membresía">
                {users.codigo_membresia}
              </span>
            )}
            {users.username || users.nombreuser || 'Usuario'}
            {diasRestantes !== null && diasRestantes > 0 && (
              <span className="ms-2 badge bg-warning text-dark" title="Días restantes de prueba">
                DEMO {diasRestantes} {diasRestantes === 1 ? 'día' : 'días'} restantes
              </span>
            )}
            {diasRestantes !== null && diasRestantes === 0 && (
              <span className="ms-2 badge bg-danger" title="Período de prueba finalizado">
                DEMO Prueba finalizada
              </span>
            )}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item className="hide-on-mobile">
          <Button
            variant="dark"
            className="ms-2"
            onClick={() => window.open(`https://wa.me/message/JH6VHHZ23H4QK1`, "_blank")}
            title="Contactar por WhatsApp - Soporte Técnico"
          >
            <FaIcons.FaWhatsapp /> Soporte Técnico
          </Button>
        </Nav.Item>
        <Nav.Item className="hide-on-mobile">
          <Link to="/membresias" className="btn btn-success ms-2">
            <FaIcons.FaCrown /> UPGRADE
          </Link>
        </Nav.Item>
        <Nav.Item className="hide-on-mobile">
          <div className="position-relative">
            <Button
              variant="outline-light"
              className="ms-2 position-relative"
              onClick={toggleNotificaciones}
              title="Notificaciones"
            >
              <FaIcons.FaBell />
              {notificacionesNoLeidas > 0 && (
                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  {notificacionesNoLeidas}
                </span>
              )}
            </Button>
            
            {/* Panel de Notificaciones */}
            {showNotificaciones && (
              <div className="notificaciones-panel">
                <div className="notificaciones-header">
                  <h6 className="mb-0">🔔 Notificaciones</h6>
                  <small className="text-muted">{notificaciones.length} total</small>
                </div>
                
                {/* Formulario para enviar notificación (solo admin) */}
                {users.rol === "admin" && (
                  <div className="notificaciones-form">
                    <h6 className="mb-2">📤 Enviar Notificación</h6>
                    <div className="mb-2">
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        placeholder="Título de la notificación"
                        value={nuevaNotificacion.titulo}
                        onChange={(e) => setNuevaNotificacion({...nuevaNotificacion, titulo: e.target.value})}
                      />
                    </div>
                    <div className="mb-2">
                      <textarea
                        className="form-control form-control-sm"
                        rows="2"
                        placeholder="Mensaje de la notificación"
                        value={nuevaNotificacion.mensaje}
                        onChange={(e) => setNuevaNotificacion({...nuevaNotificacion, mensaje: e.target.value})}
                      />
                    </div>
                    <div className="mb-2">
                      <select
                        className="form-select form-select-sm"
                        value={nuevaNotificacion.tipo}
                        onChange={(e) => setNuevaNotificacion({...nuevaNotificacion, tipo: e.target.value})}
                      >
                        <option value="info">ℹ️ Informativa</option>
                        <option value="success">✅ Éxito</option>
                        <option value="warning">⚠️ Advertencia</option>
                        <option value="error">❌ Error</option>
                      </select>
                    </div>
                    <Button
                      variant="primary"
                      size="sm"
                      onClick={enviarNotificacion}
                      className="w-100"
                    >
                      Enviar
                    </Button>
                  </div>
                )}
                
                {/* Lista de notificaciones */}
                <div className="notificaciones-lista">
                  {notificaciones.length > 0 ? (
                    notificaciones.map((notif) => (
                      <div
                        key={notif.id}
                        className={`notificacion-item ${!notif.leida ? 'no-leida' : ''}`}
                        onClick={() => marcarComoLeida(notif.id)}
                      >
                        <div className="d-flex align-items-start">
                          <div className={`notificacion-icono text-${getTipoColor(notif.tipo)} me-2`}>
                            {getTipoIcono(notif.tipo)}
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="mb-1">{notif.titulo}</h6>
                            <p className="mb-1 small">{notif.mensaje}</p>
                            <small className="text-muted">
                              {new Date(notif.fecha_creacion).toLocaleDateString('es-ES')}
                            </small>
                          </div>
                          {!notif.leida && (
                            <div className="notificacion-punto"></div>
                          )}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-3">
                      <p className="text-muted mb-0">No hay notificaciones</p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </Nav.Item>
        <Nav>
          <NavDropdown
            id="nav-dropdown-dark-example"
            title={<FaIcons.FaRegSun className="nav-text-white" />}
          >
            <NavDropdown.Item>
              <Link to="/usuarios/info" className="enlacenav nav-text-dark">
                Mis datos
              </Link>
            </NavDropdown.Item>
             {users.rol === "admin" && (
             <NavDropdown.Item>
              <Link to="/updatewhatsapp" className="enlacenav nav-text-dark">
                Num. de WhatsApp
              </Link>
            </NavDropdown.Item>
             )}
            {users.rol === "cliente" && (
              <NavDropdown.Item>
                <Link to="/contactanos" className="enlacenav nav-text-dark">
                  Contáctanos
                </Link>
              </NavDropdown.Item>
            )}
            {users.rol === "cliente" && (
              <NavDropdown.Item>
                <Link to="/recomienda" className="enlacenav nav-text-dark">
                  Recomienda un amigo
                </Link>
              </NavDropdown.Item>
            )}
            {/* {users.rol === "cliente" && (
              <NavDropdown.Item>
                <Link
                  to="/invitaalaacademia"
                  className="enlacenav nav-text-dark"
                >
                  Invita a la academia
                </Link>
              </NavDropdown.Item>
            )} */}
            {/* <NavDropdown.Item>
              <Link to="/informacion" className="enlacenav nav-text-dark">
                Informacion del sistema
              </Link>
            </NavDropdown.Item> */}
            <NavDropdown.Item>
              <p
                className="enlacenav nav-text-dark"
                onClick={() => handlelogout()}
              >
                Salir
              </p>
            </NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Nav>
      {/* ---------------------------------------Sidebar------------------------------------------------ */}
      <div className="container_side">
        <div style={{ width: isOpen ? "220px" : "60px" }} className="sidebar">
          <div className="top_section">
            <h1 style={{ display: isOpen ? "block" : "none" }} className="logo">
              <img src={logovefase} alt="some value" />
            </h1>
            <div
              style={{ marginLeft: isOpen ? "200px" : "0px" }}
              className="bars"
            >
              <FaIcons.FaBars onClick={toggle} className="bars-icon" />
            </div>
          </div>
          <div style={{ display: isOpen ? "block" : "none" }}>
            <div style={{ background: isOpen ? "#000" : "#edf1f5" }}>
              <Accordion className="acordion" defaultActiveKey="0">
                {users.rol === "cliente" && (
                  <Accordion.Item>
                    <Link to="/iniciouser" className="enlace">
                      <Accordion.Header>
                        <FaIcons.FaThLarge className="icon-spacing" /> Inicio
                      </Accordion.Header>
                    </Link>
                  </Accordion.Item>
                )}
                {users.rol === "admin" && (
                  <Accordion.Item>
                    <Link to="/inicio" className="enlace">
                      <Accordion.Header>
                        <FaIcons.FaThLarge className="icon-spacing" /> Inicio
                      </Accordion.Header>
                    </Link>
                  </Accordion.Item>
                )}
                <Accordion.Item>
                  <Link to="/chat-ia" className="enlace">
                    <Accordion.Header>
                      <FaIcons.FaRobot className="icon-spacing" /> Chat IA
                    </Accordion.Header>
                  </Link>
                </Accordion.Item>
                {(users.rol === "admin" || users.rol === "administrador") && (
                  <Accordion.Item>
                    <Link to="/actualizar-ia" className="enlace">
                      <Accordion.Header>
                        <FaIcons.FaFileUpload className="icon-spacing" /> Subir DOCs IA
                      </Accordion.Header>
                    </Link>
                  </Accordion.Item>
                )}
                {users.rol === "admin" && (
                  <Accordion.Item eventKey="4">
                    <Accordion.Header>
                      <FaIcons.FaNetworkWired className="icon-spacing" />{" "}
                      Usuarios
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/trabajadores">Gestionar</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
                {users.rol === "admin" && (
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <FaIcons.FaRobot className="icon-spacing" /> Campañas
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/usuariossstrade/">Gestionar</Link>
                      <br></br>
                      <br></br>
                      <Link to="/seleccion-tipo-campana">Registrar</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
                {users.rol === "cliente" && (
                  <Accordion.Item eventKey="1">
                    <Accordion.Header>
                      <FaIcons.FaRobot className="icon-spacing" /> Campañas
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/mislanding/">Gestionar</Link>
                      <br></br>
                      <br></br>
                      <Link to="/seleccion-tipo-campana">Registrar</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
                {users.rol === "cliente" && (
                  <Accordion.Item eventKey="11">
                    <Accordion.Header>
                      <FaIcons.FaCopy className="icon-spacing" /> Leads Captados
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/leads/">Gestionar</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}

                 
                {users.rol === "cliente" && (
                  <Accordion.Item eventKey="114">
                    <Link to="/cirpacademy/" className="enlace">
                      <Accordion.Header>
                        <FaIcons.FaYoutube className="icon-spacing" /> Katana
                        Academy
                      </Accordion.Header>
                    </Link>
                  </Accordion.Item>
                )}
                   {users.rol === "admin" && (
                  <Accordion.Item eventKey="11">
                    <Accordion.Header>
                      <FaIcons.FaCopy className="icon-spacing" /> Leads Captados
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/leadstodos/">Gestionar</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}

                 {users.rol === "admin" && (
                   <Accordion.Item eventKey="120">
                    <Accordion.Header>
                      <FaIcons.FaYoutube className="icon-spacing" />Katana Academy
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/crearcursos/">Crear curso</Link>
                      <br></br>
                    </Accordion.Body>
                    <Accordion.Body>
                      <Link to="/cursos/">Gestionar cursos</Link>
                      <br></br>
                    </Accordion.Body>
                    <Accordion.Body>
                      <Link to="/lecciones/">Gestionar Lecciones</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}

                {users.rol === "admin" && (
                  <Accordion.Item eventKey="121">
                    <Accordion.Header>
                      <FaIcons.FaBell className="icon-spacing" /> Crear Notificaciones
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/crear-notificaciones/">Gestionar Notificaciones</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}

                {users.rol === "admin" && (
                  <Accordion.Item eventKey="122">
                    <Accordion.Header>
                      <FaIcons.FaComments className="icon-spacing" /> Gestionar Comentarios
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/gestionar-comentarios/">Moderar Comentarios</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}

                {users.rol === "admin" && (
                  <Accordion.Item eventKey="124">
                    <Link to="/reportes" className="enlace">
                      <Accordion.Header>
                        <FaIcons.FaChartLine className="icon-spacing" /> Reportes
                      </Accordion.Header>
                    </Link>
                  </Accordion.Item>
                )}

                {users.rol === "admin" && (
                  <Accordion.Item eventKey="125">
                    <Link to="/network-leadership-academy" className="enlace">
                      <Accordion.Header>
                        <FaIcons.FaGraduationCap className="icon-spacing" /> Network Leadership Academy
                      </Accordion.Header>
                    </Link>
                  </Accordion.Item>
                )}

                 {users.rol === "cliente" && (
                  <Accordion.Item eventKey="124">
                    <Link to="/reportesuser" className="enlace">
                      <Accordion.Header>
                        <FaIcons.FaChartLine  className="icon-spacing" /> Reportes
                      </Accordion.Header>
                    </Link>
                  </Accordion.Item>
                )}

                {users.rol === "cliente" && (
                  <Accordion.Item eventKey="126">
                    <Link to="/network-leadership-academy-redirect" className="enlace">
                      <Accordion.Header>
                        <FaIcons.FaGraduationCap className="icon-spacing" /> Network Leadership Academy
                      </Accordion.Header>
                    </Link>
                  </Accordion.Item>
                )}

                {users.rol === "cliente" && (
                  <Accordion.Item eventKey="12">
                    <Accordion.Header>
                      <FaIcons.FaInfoCircle className="icon-spacing" /> Datos campañas
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/misdatosuser/">Gestionar</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
                
                 {users.rol === "cliente" && (
                  <Accordion.Item eventKey="124">
                    <Link to="/encuesta" className="enlace">
                      <Accordion.Header>
                        <FaIcons.FaPoll  className="icon-spacing" /> Encuestas
                      </Accordion.Header>
                    </Link>
                  </Accordion.Item>
                )}
                {users.rol === "cliente" && (
                  <Accordion.Item eventKey="14">
                    <Accordion.Header>
                      <FaIcons.FaFacebookF className="icon-spacing" /> Pixels
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/pixels/">Gestionar</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
                 {users.rol === "cliente" && (
                  <Accordion.Item eventKey="34">
                    <Accordion.Header>
                      <FaIcons.FaMicrosoft className="icon-spacing" />Clarity
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/clarity/">Gestionar</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
                 {users.rol === "cliente" && (
                  <Accordion.Item eventKey="35">
                    <Accordion.Header>
                      <FaIcons.FaEnvelope className="icon-spacing" />Brevo
                    </Accordion.Header>
                    <Accordion.Body>
                      <Link to="/brevo/">Gestionar</Link>
                      <br></br>
                    </Accordion.Body>
                  </Accordion.Item>
                )}
              </Accordion>
            </div>
          </div>
        </div>

        <main>{children}</main>
        
        {/* Chat de IA flotante */}
        <AIChat />
      </div>
    </div>
  );
};

export default Sidebar;